import { MIN_PASSWORD_LENGTH } from "../../shared/passwordChange";

/** How many characters a new password still lacks; none once it is long enough. */
export const missingCharacters = (newPassword: string): number =>
  Math.max(0, MIN_PASSWORD_LENGTH - newPassword.length);

/** Whether what is entered for a change of password can be sent. */
export const canChangePassword = ({
  current,
  next,
  repeat,
}: {
  current: string;
  next: string;
  repeat: string;
}): boolean =>
  current !== "" && missingCharacters(next) === 0 && repeat === next;
